import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { ThemeProvider } from '@mui/material/styles';

import { App } from './App.tsx';
import { AuthProvider } from './auth/AuthContext.tsx';
import { CurrencyProvider } from './currency/CurrencyContext.tsx';
import { MODE_STORAGE_KEY, theme } from './theme.ts';

const container = document.getElementById('root');
if (!container) throw new Error('root element not found');

createRoot(container).render(
  <StrictMode>
    <InitColorSchemeScript attribute="data-mui-color-scheme" modeStorageKey={MODE_STORAGE_KEY} defaultMode="system" />
    <ThemeProvider theme={theme} defaultMode="system" modeStorageKey={MODE_STORAGE_KEY}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <App />
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
